import { addMutator } from '@poa/state';

import {
  updateAccount,
  fetchAccount,
  fetchAccountReportsSuccess,
  fetchAccounts,
  refreshAccounts,
  fetchAccountSuccess,
  fetchAccountFailed,
  fetchAccountsSuccess,
  fetchAccountsFailed,
  createShiftPeriodSuccess,
  createShiftPeriodFailed,
  setDates,
  saveColumnPreset,
  toggleFavorite,
  fetchShiftTransfersSuccess,
  fetchShiftMapSuccess,

  // presets
  changeColumnPreset,
  changeColumnVisibility,
  changeRounding,
  changeSearch,
  resetColumnSettings,
  toggleAllColumns,
  changePresetOrder,
  deletePreset
} from './accounts.actions';
import { clone } from '../shared/clone';

// fetch
addMutator(fetchAccount, (_, { store }) => {
  store.accounts.meta.isLoading = true;
  store.accounts.meta.hasError = false;
});

addMutator(updateAccount, (_, { store }) => {
  store.accounts.meta.isLoading = true;
  store.accounts.meta.hasError = false;
});

addMutator(fetchAccounts, (_, { store }) => {
  store.accounts.meta.isLoading = true;
  store.accounts.meta.hasError = false;
});

addMutator(refreshAccounts, (_, { store }) => {
  store.accounts.meta.isLoading = true;
  store.accounts.meta.hasError = false;
});

addMutator(fetchAccountSuccess, ({ data }, { store }) => {
  store.accounts.meta.isLoading = false;
  store.accounts.meta.hasError = false;
  store.accounts.originalModel = data;
  store.accounts.model = data;

  store.accounts.meta.loaded = true;
});

addMutator(fetchAccountReportsSuccess, ({ data }, { store }) => {
  store.accounts.reports = data.reports || [];

  if (store.accounts.activeReportId === null) {
    store.accounts.activeReport = data.reports.length > 0 ? data.reports[0] : {
      id: null,
      name: '',
      instruction: '',
      result: '',
      date_updated: "TODAY",
      date_created: "TODAY"
    };
    store.accounts.activeReportId = data.reports.length > 0 ? data.reports[0].id : null;
  } else {
    store.accounts.activeReport = data.reports.find(
      report => report.id === store.accounts.activeReportId
    ) || {
      id: null,
      name: '',
      instruction: '',
      result: '',
      date_updated: "TODAY",
      date_created: "TODAY"
    };
  }

});

addMutator(fetchAccountFailed, (payload, { store }) => {
  store.accounts.meta.isLoading = false;
  store.accounts.meta.hasError = true;
});

addMutator(fetchAccountsSuccess, ({ data }, { store }) => {
  store.accounts.meta.isLoading = false;
  store.accounts.meta.hasError = false;

  if (data.data) {
        store.accounts.data.replace(data.data);
      } else {
    store.accounts.data.replace(data);
  }

  store.accounts.meta.loaded = true;
});

addMutator(fetchAccountsFailed, (payload, { store }) => {
  store.accounts.meta.isLoading = false;
  store.accounts.meta.hasError = true;
});

// ui
addMutator(toggleFavorite, ({ id }, { store }) => {
  const { favorites } = store.accounts.ui;

  const idx = favorites.indexOf(id);

  if (idx === -1) {
    // add new
    favorites.push(id);
  } else {
    // remove existing
    favorites.splice(idx, 1);
  }
});

addMutator(setDates, ({ startDate, endDate }, { store }) => {
  store.accounts.filters.startDate = startDate;
  store.accounts.filters.endDate = endDate;
});

// presets
addMutator(changeColumnPreset, ({ presetId }, { store }) => {
  store.accounts.filters.columnSettings.currentPresetId = presetId;

  store.accounts.filters.columnSettings.lastSelectedPresetColumns = clone(
    store.accounts.selectors.selectedPreset.columnsConfiguration
  );
});

addMutator(changeColumnVisibility, ({ column }, { store }) => {
  column.isSelected = !column.isSelected;
});

addMutator(toggleAllColumns, (_, { store }) => {
  const newStatus = !store.accounts.selectors.isAllColumnsSelected;

  store.accounts.selectors.selectedPreset.columnsConfiguration.forEach(
    c => (c.isSelected = newStatus)
  );
});

addMutator(saveColumnPreset, ({ preset }, { store }) => {
  const { selectedPreset } = store.accounts.selectors;
  const { columnSettings } = store.accounts.filters;
  const savedColumnsConfiguration = clone(selectedPreset.columnsConfiguration);

  const newPreset = {
    id: Math.random(),
    label: preset.label,
    columnsConfiguration: savedColumnsConfiguration
  };

  selectedPreset.columnsConfiguration = clone(columnSettings.lastSelectedPresetColumns);

  columnSettings.currentPresetId = newPreset.id;
  columnSettings.availablePresets.push(newPreset);

  columnSettings.lastSelectedPresetColumns = savedColumnsConfiguration;
});

addMutator(deletePreset, ({ id }, { store }) => {
  const { selectedPreset } = store.accounts.selectors;
  const { columnSettings } = store.accounts.filters;

  // you try to delete default preset?
  if (id === 0) {
    console.warn('You try to delete default preset. This is illegal operation.');
    return;
  }

  // find preset index that we want to delete
  const presetIndex = columnSettings.availablePresets.findIndex(preset => preset.id === id);

  // delete preset by index
  columnSettings.availablePresets.splice(presetIndex, 1);

  // apply previous preset
  columnSettings.currentPresetId = columnSettings.availablePresets[presetIndex - 1].id;
  columnSettings.lastSelectedPresetColumns = clone(selectedPreset.columnsConfiguration);
});

addMutator(resetColumnSettings, ({ presetId, availablePresets }, { store }) => {
  const { selectedPreset } = store.accounts.selectors;
  const { columnSettings } = store.accounts.filters;

  columnSettings.currentPresetId = presetId;
  columnSettings.availablePresets = availablePresets;

  columnSettings.lastSelectedPresetColumns = clone(selectedPreset.columnsConfiguration);
});

addMutator(changeRounding, ({ isDecimal }, { store }) => {
  store.accounts.filters.isDecimal = isDecimal;
});

addMutator(changeSearch, ({ searchClause }, { store }) => {
  store.accounts.filters.search = searchClause;
});

addMutator(changePresetOrder, ({ columns }, { store }) => {
  const { selectedPreset } = store.accounts.selectors;

  selectedPreset.columnsConfiguration = columns.map(columnName =>
    selectedPreset.columnsConfiguration.find(colConfig => colConfig.name === columnName)
  );
});


addMutator(createShiftPeriodSuccess, ({ data }, { store }) => {
  store.accounts.originalModel.shifts = data;
});

addMutator(fetchShiftTransfersSuccess, ({ data }, { store }) => {
  store.accounts.originalModel.shiftsHistory = data;
});

addMutator(createShiftPeriodFailed, (payload, { store }) => {
  store.accounts.meta.isLoading = false;
  store.accounts.meta.hasError = true;
});

addMutator(fetchShiftMapSuccess, ({ data }, { store }) => {
  store.accounts.map_data.replace(data.data);
});